import AdminMenuMobileContent from "../../../components/Admin/MenuMobile"

const AdminMenuMobile = () => {

    return (
        <>
            <AdminMenuMobileContent />
        </>
    )

}

export default AdminMenuMobile